import React, { useState } from "react";
import { ArrowRightOutlined, CheckCircleFilled, CloseOutlined } from "@ant-design/icons";
import { ReactComponent as ProfileIcon } from "../../../../../assets/icons/Profile.svg";
import { ReactComponent as JobIcon } from "../../../../../assets/icons/Job.svg";
import { ReactComponent as BidIcon } from "../../../../../assets/icons/Bid.svg";
import { ReactComponent as TrialIcon } from "../../../../../assets/icons/Trial.svg";
import { ReactComponent as WelcomeHandIcon } from "../../../../../assets/icons/WelcomeHand.svg";
import styles from "./DashboardSetupWidget.module.css";

const DashboardSetupWidget = ({
  name = "User",
  percentCompleted = 0,
  showTrialBanner = true,

  isOnboardingcompleted = false,
  isProfileCompleted = false,
  isCurrentEmployerPostedJob = false,
  isCurrentEmployerPostedBid = false,

  onCompleteProfile,
  onPostJob,
  onPlaceBid,
}) => {
  const bannerStorageKey = "trialBannerClosed";
  const [isBannerVisible, setIsBannerVisible] = useState(() => {
    return localStorage.getItem(bannerStorageKey) !== "true";
  });

  const closeBanner = () => {
    setIsBannerVisible(false);
    localStorage.setItem(bannerStorageKey, "true");
  };

  const RowItem = ({ icon, title, desc, onClick, done = false }) => {
    const clickable = !!onClick && !done;

    return (
      <div
        className={`${styles.row} ${clickable ? styles.rowClickable : ""}`}
        onClick={clickable ? onClick : undefined}
      >
        <div className={styles.rowIcon}>
          {done ? (
            <CheckCircleFilled className={styles.doneIcon} />
          ) : (
            <span className={styles.iconMuted}>{icon}</span>
          )}
        </div>

        <div className={styles.rowMain}>
          <div className={styles.rowTitleLine}>
            <span className={styles.rowTitle}>{title}</span>
            {clickable ? <ArrowRightOutlined className={styles.titleArrow} /> : null}
          </div>

          {desc ? <div className={styles.rowDesc}>{desc}</div> : null}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.wrap}>
      {showTrialBanner && isBannerVisible && (
        <div className={styles.banner}>
          <div className={styles.bannerLeft}>
            <div style={{marginTop: '7px'}}><TrialIcon /></div>
            <div className={styles.bannerText}>
              <div className={styles.bannerTitle}>Free Trial Activated!</div>
              <div className={styles.bannerDesc}>
                Your 7-day free trial is live! Start exploring features,
                discover top talent, and create your first job.
              </div>
            </div>
          </div>

          <button
            type="button"
            className={styles.bannerClose}
            onClick={closeBanner}
          >
            <CloseOutlined />
          </button>
        </div>
      )}

      {/* Welcome */}
      <div className={styles.welcome}>
        <div className={styles.welcomeTitle}>
          <span className={styles.hand}>
            <WelcomeHandIcon />
          </span>
          <span className={styles.welcomeName}>Welcome, {name}</span>
        </div>

        <div className={styles.welcomeSub}>
          Your dashboard is ready. Let’s set things up.
        </div>
      </div>

      {/* Card */}
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.cardHeaderLeft}>
            <div className={styles.cardTitle}>
              Lets get started in SkillGigs
            </div>

            <span className={styles.badge}>
              {percentCompleted}% Completed
            </span>
          </div>
        </div>

        <div className={styles.rows}>
          <RowItem
            done={isOnboardingcompleted}
            title="Onboarding Complete"
          />

          <RowItem
            icon={<ProfileIcon />}
            done={isProfileCompleted}
            title="Complete Profile"
            desc="Complete your profile to attract the right talent faster and get better-matched applications."
            onClick={onCompleteProfile}
          />

          <RowItem
            icon={<JobIcon />}
            done={isCurrentEmployerPostedJob}
            title="Post a Job"
            desc="Post a job to reach qualified talent and start receiving relevant applications quickly."
            onClick={onPostJob}
          />

          <RowItem
            icon={<BidIcon />}
            done={isCurrentEmployerPostedBid}
            title="Place a Bid"
            desc="Review talent and place a bid to engage the right talent for your role."
            onClick={onPlaceBid}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardSetupWidget;
